<template>
  <div>
    <FixedButton>
      <el-button
        type="primary"
        plain
        @click="handleExport"
        v-loading.fullscreen.lock="fullLoading"
        element-loading-text="正在导出..."
        >导出</el-button
      >
      <el-button class="myBtn" type="primary" plain @click="handleImportModel">导入模板</el-button>
      <el-upload
        class="myBtn"
        action=""
        accept=".xls, .xlsx"
        :show-file-list="false"
        :http-request="handleImport"
      >
        <el-button type="primary" plain>导入</el-button>
      </el-upload>
      <el-button type="primary" @click.stop="handleAdd" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <Dialog :row="row" v-if="visible" @refresh="formSearch" :visible.sync="visible" />
    <ImportError
      :tableErrorData="tableErrorData"
      v-if="showImportError"
      :dialog.sync="showImportError"
    ></ImportError>
  </div>
</template>

<script>
import formjson from './Model/Formjson.List'
import tablejson from './Model/Tablejson.List'
import formTableMixin from '@manage/mixins/formTableMixin'
import { downloadFile } from '@manage/utils/download'
import Dialog from './dialog'
import ImportError from './importError'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit'
        },
        {
          name: '详情',
          type: 'detail'
        },
        {
          name: '删除',
          type: 'delete'
        },
        {
          name: '定位',
          type: 'map',
          hide(row) {
            return !row.latitude || !row.longitude
          }
        }
      ],
      visible: false,
      showImportError: false,
      row: {},
      queryApi: this.$api.freezer.device_list,
      deleteApi: this.$api.freezer.device_delete,
      exportApi: this.$api.freezer.device_export,
      importApi: this.$api.freezer.device_import,
      importTemplateApi: this.$api.freezer.device_import_template
    }
  },
  computed: {
    fullLoading() {
      return this.$store.state.fullLoading
    }
  },
  components: {
    Dialog,
    ImportError
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      params.devType = '02' // 01厨冷 02红酒
      this.search(params, null, this.queryApi)
    },
    handleAdd() {
      this.row = {}
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleExport() {
      this.$confirm('确认导出?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.commit('SET_FULL_LOADING', true)
          let params = {
            ...this.cacheData
          }
          params.devType = '02' // 01厨冷 02红酒
          this.$ajax.download(this.exportApi, params).then((res) => {
            this.$store.commit('SET_FULL_LOADING', false)
            downloadFile(res)
          })
        })
        .catch(() => {})
    },
    handleImportModel() {
      let params = {}
      params.devType = '02' // 01厨冷 02红酒
      this.$ajax.download(this.importTemplateApi, params).then((res) => {
        downloadFile(res)
      })
    },
    handleImport(res) {
      let formdata = new FormData()
      formdata.append('file', res.file)
      formdata.append('devType', '02')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      this.$ajax.post(this.importApi, formdata, config).then((res) => {
        if (res.success) {
          this.$message.success('导入成功')
          this.formSearch()
        } else {
          if (res.data) {
            this.tableErrorData = []
            for (let i in res.data) {
              this.tableErrorData.push({
                errorRecord: i,
                errorMsg: res.data[i]
              })
            }
            this.showImportError = true
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    handleDetail(row) {
      this.$router.push(
        '/wine/list/detail?id=' + row.id + '&assetNumber=' + row.assetNumber + '&room=' + row.room
      )
    },
    handleMap(row) {
      this.$router.push('/wine/map?assetNumber=' + row.assetNumber)
    },
    handleDelete(row) {
      this.$confirm('是否删除该设备', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.freezer.device_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'map':
          this.handleMap(row)
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.myBtn {
  margin-right: 10px;
}
.el-table {
  .system-defined {
    background: #f0f9eb;
  }
}
</style>
